import axiosInstance from 'api/axiosInstance';

// Backend API response type
interface ProspectHistoryEventType {
	Id: number;
	Type: string;
}

// API response type
interface SProspectHistoryEventType {
	TotalResults: string;
	Data: ProspectHistoryEventType[];
}

/**
 * Fetches the full list of prospect statuses from the `SProspectStatus` API endpoint.
 * @param {number} page - The page number to fetch (1-based index).
 * @param {number} pageSize - The number of records to fetch per page.
 * @returns {Promise<{statuses: ProspectStatus[]; total: number}>} - A promise resolving to the data formatted for usage.
 */
async function getProspectHistoryEventTypes(
	page: number = 1,
	pageSize: number = 20,
): Promise<{ eventTypes: ProspectHistoryEventType[]; total: number }> {
	try {
		const { data } = await axiosInstance.get<SProspectHistoryEventType>(
			`/api/cantrackv3/SProspectHistoryEventType`,
			{
				params: {
					id: 0, // Default ID
					searchKeyword: '', // No filtering
					page, // Page number
					take: pageSize, // Number of records
				},
			},
		);

		const totalResults = parseInt(data.TotalResults || '0', 10);

		return {
			eventTypes: data.Data.map((eventType) => ({
				Id: eventType.Id,
				Type: eventType.Type,
			})),
			total: totalResults,
		};
	} catch (error) {
		console.error(
			`DEBUG getProspectHistoryEventTypes.ts: Error occurred while fetching:`,
			error,
		);
		throw error;
	}
}

export default getProspectHistoryEventTypes;
